<template>
  <div class='index'>
    <!-- 选择查询条件 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="100px">
        <div class="input-box" style="margin-bottom:18px">
          <div>
            <el-form-item label="商品名称：" prop="name">
              <el-input v-model="filterForm.name" placeholder="请输入名称"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area ref="Area" :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="paging_data.currentPage=1,filterClick()" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 用户操作按钮 -->
    <div class="edit">
      <el-button
        v-if="showBtn[1].isShow"
        :disabled="selectRow.length==1?false:true"
        icon="el-icon-edit"
        @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button
        icon="el-icon-delete"
        v-if="showBtn[2].isShow"
        type="danger"
        @click="deletefuwuData('gouwu')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow">
        <file_Upload :_url="`${$api.baseUrl}${api}/import`"></file_Upload>
      </el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
      <el-button
        type="primary"
        v-if="showBtn[5].isShow"
        v-loading.fullscreen.lock="lodaingTime"
        @click="Filter_export(`${api}/export`,filterForm)"
        icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" max-height="550" border @selection-change="handleSelectionChange">
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center"
        ></el-table-column>
      </el-table>
      <paging :pagesData="paging_data" @set_page_number="get_page_number"></paging>
    </div>
    <!-- 操作数据时的弹框 -->
    <el-dialog
      title="添加商品信息"
      :visible.sync="centerDialogVisible"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      @close="close"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">添加商品信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area ref="Area" :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace" />
                        </el-form-item>
                        <el-form-item label="企业名称：">
                          <el-input style="width:193px;" v-model="editForm.o_name"></el-input>
                        </el-form-item>
                        <el-form-item label="商品名称：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="商品类别：">
                          <el-input style="width:193px;" v-model="editForm.catalog"></el-input>
                          <!-- <el-select v-model="editForm.catalog" placeholder="请选择类别">
                            <el-option v-for="(o,i) in $fuwuData.catalog" :key="i" :label="o" :value="o"></el-option>
                          </el-select> -->
                        </el-form-item>
                        <el-form-item label="商品介绍：">
                          <el-input :rows="6" type="textarea" placeholder="请输入内容" v-model="editForm.description" maxlength="2000" show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="图片展示：" >
													<div class="head-img">
														<el-upload
                              ref="uploadImg" list-type="picture-card" :class="{hide:isMax}"
                              :action="uploadUrl" :file-list="fileList" :limit="1" 
                              :on-success="imgAdd" :on-error="error" :on-change="change"
                              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible" :modal="false">
                              <img width="100%" :src="imageUrl1" alt="">
                            </el-dialog>
													</div>
												</el-form-item>
                        <el-form-item label="单价：">
                          <el-input style="width:193px;" v-model="editForm.price"></el-input>
                        </el-form-item>
                        <el-form-item label="送货方式：">
                          <el-input style="width:193px;" v-model="editForm.deliveryType"></el-input>
                        </el-form-item>
                        <el-form-item label="实体店地点：">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下载模板框 -->
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

// <script>
// import mixins from '@/Mixins'
import mixins from '@/Mixins/mixin_3g48'
import mixins_headimg from '@/Mixins/mixin_3g48HeadImg'
export default {
  mixins: [mixins,mixins_headimg], 
  data() {
    return {
      type:'44',
      api:'/user/shop',
      rules:{//验证表单规则
        createlaytype: [
          // { required: 'true', message: '请选择律师擅长的案件类型', trigger: 'blur' }
        ],
      },
      filterForm:{},//筛选条件
      selectRow: [], //选中的数据加入数组
      tableData: [], //表格中的数据

      imageUrl1: '',
      headImgId:'',
      fileList:[],
      isMax:false,//默认不隐藏添加文件按钮
      dialogVisible: false,//预览图片默认不显示

      //表头
      baseInfo: [
        { key: 'province', value: '省' },
        { key: 'city', value: '市' },
        { key: 'county', value: '县' },
        { key: 'town', value: '镇' },
        { key: 'village', value: '村' },
        { key: 'name', value: '商品名称' },
        { key: 'price', value: '单价' },
        { key: 'catalog', value: '商品类别' },
        { key: 'deliveryType', value: '送货方式' },
        { key: 'address', value: '实体店地点' },
        { key: 'createTime', value: '更新时间' },
        { key: 'viewTime', value: '浏览次数' },
      ],
      centerDialogVisible:false,//控制添加数据窗口是否可见
    }
  },
  methods:{
    filterClick() {//点击查询之后=====拿到查询的条件和区域id
      let rD = {}
      rD = JSON.parse(JSON.stringify(this.filterForm))
      rD.name == '' ? delete rD.name : ''
      
      let arr = JSON.parse(JSON.stringify(this.$refs.Area.place))
      rD.areaId = arr.reverse().filter(x => !!x)[0]
      this.getData(rD)
    },
    //获取数据
    getData(rD = {}) {
      rD.beRequest = true
      rD.pageNumber = this.paging_data.currentPage
      this.userInfo.organization ? rD.beRequest = true : ''
      this.$api.util_search('gouwu', rD).then(res=> {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this.paging_data.total = res.data.size
          this.tableData = _R
          console.log(`%c列表:`, 'color: #f00;', _R)
        } else { this._status(res.data) }
      })
    },
    //编辑或创建提交表单
    submit() {
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          let rD = {}
          rD = JSON.parse(JSON.stringify(this.editForm))
          rD.province = this.province
          rD.city = this.city
          rD.county = this.county
          rD.town = this.town
          rD.village = this.village
          rD.imgUrl = this.headImgId//用于存放上传的图片ID
          this.$api.util_create('gouwu', rD).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.filterClick()
              //this.Filter_file({api:this.api,data:this.form,callback:_d => this.tableData = _d })
            } else { this._status(res.data) }
          })
        } else if (valid && this.isCreate === false) {
          let requestData = {}
          let mapList = [//以下属性是，发生改变的时候才传
            'o_name',
            'updateTime', 
            'viewTime',
            'address',
            'description',
            'name',
            'catalog',
            'deliveryType',
            'imgUrl',
            'price',
          ]
          let mapList2 = [//无论是否发生改变 都必须传
            'province',
            'city',
            'county',
            'town',
            'village',
          ]
          this.editForm.imgUrl = this.headImgId;
          this.editForm.province = this.province
          this.editForm.city = this.city
          this.editForm.county = this.county
          this.editForm.town = this.town
          this.editForm.village = this.village
          // console.log('选中的数据',this.selectRow[0])
          // console.log('编辑框中的数据',this.editForm)
          mapList.forEach(o => {//将修改过的属性和值赋给requestData
            this.editForm[o] != this.selectRow[0][o] ? requestData[o] = this.editForm[o] : ''
          })
          mapList2.forEach(o => {//无论是否发生改动，都必须将完整的区域名发送过去
            requestData[o] = this.editForm[o]
          })
          requestData.id = this.selectRow[0].id;
          this.$api.util_modify('gouwu', requestData).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!');
              this.filterClick()
            } else { this._status(res.data) }
          })
          
        } else {
            return false
        }
      })
      this.centerDialogVisible = false;//隐藏弹框
    },

    //多选框被选中时,将选中的数据集合赋值给数组
    handleSelectionChange(val) {
      this.selectRow = val;
    },
     //头像        
		handleAvatarSuccess1(res, file) {
			this.$message.success('上传成功！')
			this.imageUrl1 = URL.createObjectURL(file.raw)
			this.headImgId = this.$api.imgUrl_ + res.data
    },
    beforeAvatarUpload1(file) {
			const isJPG = file.type === 'image/jpeg' || file.type === 'png'
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!isJPG) { this.$message.error('上传图片只能是 JPG、PNG 格式!') }
			if (!isLt2M) { this.$message.error('上传图片大小不能超过 2MB!') }
			return isJPG && isLt2M
    },
  },
  created() {
    this.isShowBtn('Shop')//控制操作按钮的显示与隐藏
    //渲染地区下拉框
    this.getArea({ value: { areaId: 0 }, key: 0 });
    this.init()
  },
}
</script>

<style lang='scss' scoped>
/deep/ .hide .el-upload--picture-card {
  display: none;
}
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.head-img {
	height: 148px;
	width: 148px;
	border-radius: 5px;
}
/deep/ .head-img .el-upload-list__item {
  transition: none !important;
}
.el-textarea .el-textarea__inner {
  resize: none;
}
.info-input .el-tabs--border-card>.el-tabs__content {
	padding: 10px 0 10px 0!important;
} 
.avatar-uploader .el-upload {
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 150px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 150px;
	height: 178px;
	display: block;
}
</style>